import './AvatarButton.scss'

import { HDSAvatar, HDSAvatarButton } from '@here/hds-react-components'
import React from 'react'

import { HereAccount } from '../data/reducer'
import { createInitials } from '../lib/utils'

interface AvatarButtonProps {
  user?: HereAccount
  imageUrl?: string
  onClick: () => void
}

export function AvatarButton(props: AvatarButtonProps): JSX.Element {
  const { onClick, user, imageUrl } = props
  const name = user ? createInitials(user) : ''
  return (
    <HDSAvatarButton className="AvatarButton__main" onClick={onClick}>
      <HDSAvatar name={name} imageUrl={imageUrl} size="large" />
    </HDSAvatarButton>
  )
}
